<template>
    <div>
        <div v-if="isUrl">
            <iframe v-if="isYoutubeVideo" width="560" height="315" :src="fieldValue" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            <a v-else :href="fieldValue" target="_blank">{{fieldValue}}</a>
        </div>
        <label-renderer v-else-if="isLabel" :component="component.component" :label-value="fieldValue"
                        :containerWidth="containerWidth"></label-renderer>
        <header-renderer v-else-if="isHeader" :component="component.component" :header-value="fieldValue"></header-renderer>
        <div v-else class="my-1">{{fieldValue}}</div>
    </div>
</template>

<script>
    import LabelRenderer from "../views/renderers/LabelRenderer.vue";
    import HeaderRenderer from "../views/renderers/HeaderRenderer.vue";
    export default {
        name: 'StringRenderer',
        components: {HeaderRenderer, LabelRenderer},
        props: ['field', 'document', 'component', 'containerWidth'],
        computed: {
            fieldValue() {
                return this.document[this.field.index]
            },
            isUrl() {
                return this.fieldValue.indexOf('http') === 0
            },
            isYoutubeVideo() {
                return this.fieldValue.indexOf('https://www.youtube.com') > -1
            },
            hasChildComponent() {
                return !!(this.component && this.component.component && this.component.component.type)
            },
            isLabel() {
                return this.hasChildComponent && this.component.component.type === 'Label'
            },
            isHeader() {
                return this.hasChildComponent && this.component.component.type === 'Header'
            }
        },
        data () {
            return {
                model: webase.model
            }
        }
    }
</script>

<style>

</style>
